export default "__VITE_ASSET__B_hVST12__"